import styled from 'styled-components'
import { Box, Typography } from 'src/components'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

export const Container = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    position: fixed;
    top: 0;
    justify-content: space-between;
    z-index: 200;
    width: 100%;
    background: ${({ theme }) => theme.colors.background};
    backdrop-filter: blur(35.5px);

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        justify-content: center;
        align-items: center;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1380px;
        background: ${({ theme }) => theme.colors.hamburger};
        backdrop-filter: blur(35.5px);
        border-radius: 0 0 20px 20px;
        justify-content: center;
        align-items: center;
    }
`

export const LimitContainer = styled(Box)`
    width: 100%;
    display: flex;
    flex-direction: row;
    height: 44px;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 200;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 90%;
        justify-content: space-between;
        height: 43.26px;
        align-items: center;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1280px;
        justify-content: start;
        align-items: center;
        height: 54px;
    }
`

export const ContentTypography = styled(Typography)`
    font-family: inherit;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 20px;
        font-family: inherit;
        font-style: normal;
        text-align: center;
    }
`
export const ContentTypographyNavigation = styled(Typography)`
    font-family: inherit;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 20px;
        font-family: inherit;
        font-style: normal;
        text-align: center;
    }
`
export const Content = styled(Link)`
    color: ${({ theme }) => theme.colors.white};
`

export const ContentButton = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 400px;
    }
`

export const LinkButton = styled(motion(Link))`
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`

export const MenuButtonDes = styled.button`
    border: none;
    background: transparent;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: ${({ theme }) => theme.colors.white};
    :before {
        border: none;
    }
    :active {
        border: none;
    }
    :after {
        border: none;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        color: ${({ theme }) => theme.colors.white};
    }
`
